import { v4 as uuidv4 } from "uuid";

function chillHop() {
  return [
    {
      name: "Brown Munde",
      artist: "AP Dhillon, Gurinder Gill",
      cover:
        "https://img.wynk.in/unsafe/275x275/filters:no_upscale():format(webp)/http://s3-ap-south-1.amazonaws.com/wynk-music-cms/srch_hungama/music/859742042973/1606930830/srch_hungama_58795730.jpg",
      id: uuidv4(),
      active: true,
      color: ["#F13E2E", "#2C3536"],
      audio: "https://dns4.pendusaab.com/download/128k-dcqrg/Brown-Munde.mp3",
    },

    {
      name: "Love Me Someday",
      artist: "Maninder Buttar",
      cover:
        "https://cover.djpunjab.org/49990/300x700/Jugni-Maninder-Buttar.jpg",
      id: uuidv4(),
      active: false,
      color: ["#629CBA", "#113462"],
      audio:
        "https://cdnsongs.com/music/data/Single_Track/202103/Love_Me_Someday/128/Love_Me_Someday_1.mp3",
    },

    {
      name: "Guilty",
      artist: "Inder Chahal, Karan Aujla",
      cover:
        "https://pagalfree.com/images/128Guilty%20-%20Karan%20Aujla%20128%20Kbps.jpg",
      id: uuidv4(),
      active: false,
      color: ["#653541", "#AC1910"],
      audio:
        "https://pagalfree.com/musics/128-Guilty - Karan Aujla 128 Kbps.mp3",
    },

    {
      name: "Gal Sun",
      artist: "Jass Manak",
      cover:
        "https://pagalsong.in/uploads//thumbnails/300x300/id3Picture_244667349.jpg",
      id: uuidv4(),
      active: false,
      color: ["#E94793", "#F53959"],
      audio: "https://cdn.pagalworld.us/songs/new/192/Gal Sun - Jass Manak.mp3",
    },

    {
      name: "Hawa Banke",
      artist: "Darshan Raval",
      cover:
        "https://pagalsong.in/uploads//thumbnails/300x300/id3Picture_470423617.jpg",
      id: uuidv4(),
      active: false,
      color: ["#03162E", "#79B9C3"],
      audio:
        "https://pagalsong.in/uploads/systemuploads/mp3/Hawa Banke - Darshan Raval/Hawa Banke - Darshan Raval 128 Kbps.mp3",
    },

    {
      name: "Jatt Te Jawani",
      artist: "Dilpreet Dhillon, Karan Aujla",
      cover:
        "https://snoidcdnems08.cdnsrv.jio.com/c.saavncdn.com/083/Next-Chapter-Punjabi-2021-20210218205104-500x500.jpg",
      id: uuidv4(),
      active: false,
      color: ["#26353C", "#870202"],
      audio: "https://pwdown.info/113515/Jatt Te Jawani - Dilpreet Dhillon.mp3",
    },

    {
      name: "8 Raflaan",
      artist: "Mankirt Aulakh",
      cover: "https://cover.mr-jatt.im/thumb/497265/8-Raflaan.jpg",
      id: uuidv4(),
      active: false,
      color: ["#423833", "#AE1E09"],
      audio:
        "https://cdn.djjaani.com/upload/8_Raflaan_(Original)-Mankirt_Aulakh-(JattZone.com).mp3",
    },

    {
      name: "Teeji Seat",
      artist: "Kaka",
      cover:
        "https://1.bp.blogspot.com/-Ey23eU1AoR4/YCAJQAl1XgI/AAAAAAAAFWY/5d2Xh1bMB2026ieo5N0V42r-APNoBQw4QCLcBGAsYHQ/w640/TEEJI%2BSEAT%2BKAKA.webp",
      id: uuidv4(),
      active: false,
      color: ["#AE6867", "#3A192E"],
      audio:
        "https://cdnsongs.com/music/data/Single_Track/202102/Teeji_Seat/128/Teeji_Seat_1.mp3",
    },

    {
      name: "Akhar (Lahoriye)",
      artist: "Amrinder Gill",
      cover:
        "https://img.wynk.in/unsafe/248x248/filters:no_upscale():strip_exif():format(webp)/http://s3-ap-southeast-1.amazonaws.com/bsbcms/music/1531900708/srch_abcdigital_UKC5K1701101.jpg",
      id: uuidv4(),
      active: false,
      color: ["#3B2C31", "#B19B3E"],
      audio:
        "https://cdnsongs.com/music/data/Punjabi/201705/Lahoriye/128/Akhar.mp3",
    },

    {
      name: "Insane",
      artist: "AP Dhillon, Gurinder Gill",
      cover: "https://covers.djpunjab.pro/image/497111/Insane.jpg",
      id: uuidv4(),
      active: false,
      color: ["#885854", "#665452"],
      audio:
        "https://cdnsongs.com/music/data/Single_Track/202104/Insane/128/Insane_1.mp3",
    },

    {
      name: "Rabba Mehar Kari",
      artist: "Darshan Raval",
      cover:
        "https://pagalfree.com/images/128Rabba%20Mehar%20Kari%20-%20Darshan%20Raval%20128%20Kbps.jpg",
      id: uuidv4(),
      active: false,
      color: ["#297993", "#8D3845"],
      audio:
        "https://pagalfree.com/musics/128-Rabba Mehar Kari - Darshan Raval 128 Kbps.mp3",
    },

    {
      name: "Jee Karda",
      artist: "G Khan,Khan Saab",
      cover:
        "https://img.wynk.in/unsafe/275x275/filters:no_upscale():format(webp)/http://s3-ap-south-1.amazonaws.com/wynk-music-cms/srch_believe/music/srch_believe_A10320WT032327674J.jpg",
      id: uuidv4(),
      active: false,
      color: ["#9A3412", "#111112"],
      audio:
        "https://cdnsongs.com/music/data/Single_Track/202001/Jee_Karda/128/Jee_Karda_1.mp3",
    },

    {
      name: "Koka",
      artist: "Ranjit Bawa",
      cover:
        "https://img.wynk.in/unsafe/248x248/filters:no_upscale():strip_exif():format(webp)/http://s3-ap-south-1.amazonaws.com/wynk-music-cms/srch_sonymusic/music/A10301A0004572846Z_20210328124243840/1616948408/srch_sonymusic_A10328E0009927234L.jpg",
      id: uuidv4(),
      active: false,
      color: ["#17195B", "#BA5F4D"],
      audio:
        "https://cdnsongs.com/music/data/Single_Track/202103/Koka/128/Koka_1.mp3",
    },

    {
      name: "Daru Badnaam",
      artist: "Param Singh, Kamal Kahlon",
      cover:
        "https://img.wynk.in/unsafe/275x275/filters:no_upscale():format(webp)/http://s3-ap-south-1.amazonaws.com/wynk-music-cms/music/1526647714/srch_abcdigital_GBLQN1619802.jpg",
      id: uuidv4(),
      active: false,
      color: ["#FB0F4A", "#F0D79E"],
      audio:
        "https://cdnsongs.com/music/data/Single_Track/201612/Daru_Badnaam/128/Daru_Badnaam_1.mp3",
    },

    {
      name: "Boliyan",
      artist: "Lehmber Hussainpuri",
      cover:
        "https://a10.gaanacdn.com/images/albums/13/1433313/crop_175x175_1433313.jpg",
      id: uuidv4(),
      active: false,
      color: ["#B35237", "#F1BF10"],
      audio:
        "https://raag.fm/files/mp3/128/Punjabi/1297181/Boliyan - (Raag.Fm).mp3",
    },
  ];
}

export default chillHop;
